// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Config$PorterinUtils from "../../../../../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";
import * as AuthVm$PorterinFeature from "../../../../../login/view-model/AuthVm.mjs";
import * as GoogleStore$PorterinFeature from "../../../../../../shared/geocode/domain/store/GoogleStore.mjs";
import * as Lib$PorterinFusionkitSentry from "../../../../../../../../../node_modules/@porterin/fusionkit-sentry/src/Lib.mjs";
import * as GeocodingApi$PorterinFeature from "../../../../../../shared/geocode/domain/repo/GeocodingApi.mjs";
import * as IconTitleCmp$PorterinFeature from "./IconTitleCmp.mjs";
import * as SharedHelper$PorterinFeature from "../../../../../../shared/core/helpers/SharedHelper.mjs";
import * as ButtonIconCmp$PorterinFeature from "../../../../../../shared/button/view/ButtonIconCmp.mjs";
import * as SpotEstimateVmV1$PorterinFeature from "../../../../view-model/SpotEstimateVmV1.mjs";
import * as SpotEstimateStore$PorterinFeature from "../../../../../../shared/core/constants/SpotEstimateStore.mjs";
import * as FareEstimateStoreV1$PorterinFeature from "../../../../domain/store/FareEstimateStoreV1.mjs";
import * as PermissionDeniedCmp$PorterinFeature from "./PermissionDeniedCmp.mjs";
import * as SpotEstimateInputCmp$PorterinFeature from "../../../../../../shared/spot-lead-flow/view/components/SpotEstimateInputCmp.mjs";
import * as SelectLocationCmpModuleScss from "../styles/SelectLocationCmp.module.scss";
import * as AutoCompleteSuggestionsCmp$PorterinFeature from "../../auto-complete/AutoCompleteSuggestionsCmp.mjs";
import * as SelectLocationStateMachine$PorterinFeature from "../view-model/state-machine/SelectLocationStateMachine.mjs";
import * as FareEstimateAnalyticsHelper$PorterinFeature from "../../../../domain/helpers/FareEstimateAnalyticsHelper.mjs";
import * as GoogleAddressAutoCompleteCmp$PorterinFeature from "./GoogleAddressAutoCompleteCmp.mjs";
import * as GoogleReactAutocompleteHelper$PorterinFeature from "../../../../../../shared/core/helpers/GoogleReactAutocompleteHelper.mjs";

var styles = SelectLocationCmpModuleScss;

function SelectLocationCmp(Props) {
  var waypoint = Props.waypoint;
  var close_modal = Props.close_modal;
  var on_location_select = Props.on_location_select;
  var randomIdName = SharedHelper$PorterinFeature.getRandomIdName("pickup-address");
  var match = React.useReducer(SelectLocationStateMachine$PorterinFeature.reducer, SelectLocationStateMachine$PorterinFeature.getInitialState(undefined));
  var state = match[0];
  var landmark = state.landmark;
  var autoComletePlaceList = state.autoComletePlaceList;
  var dispatch = match[1];
  var onSearchForLocation = function (param) {
    var autoCompleteInputElm = document.getElementById(randomIdName);
    autoCompleteInputElm.focus();
  };
  return React.createElement("div", {
              className: styles["select-location-wrapper"]
            }, React.createElement(IconTitleCmp$PorterinFeature.make, {
                  close_modal: close_modal,
                  icon: AuthVm$PorterinFeature.left_arrow,
                  title: waypoint ? SpotEstimateStore$PorterinFeature.select_location_dropoff_title : SpotEstimateStore$PorterinFeature.select_location_pickup_title
                }), React.createElement("div", {
                  className: styles["form-container"]
                }, React.createElement(SpotEstimateInputCmp$PorterinFeature.make, {
                      label: waypoint === /* Pickup */0 ? FareEstimateStoreV1$PorterinFeature.pickup_address : FareEstimateStoreV1$PorterinFeature.dropoff_address,
                      is_required: true,
                      is_filled: landmark.length === 0,
                      children: React.createElement(GoogleAddressAutoCompleteCmp$PorterinFeature.make, {
                            id: randomIdName,
                            value: landmark,
                            api_key: Config$PorterinUtils.google_maps_api_key,
                            form_on_change: (function (address, param) {
                                Curry._1(dispatch, {
                                      TAG: /* SetLandmark */1,
                                      _0: address.landmark
                                    });
                              }),
                            placeholder: "",
                            on_focus: (function (param) {
                                Curry._1(dispatch, {
                                      TAG: /* SetIsPermissionDenied */2,
                                      _0: false
                                    });
                              }),
                            on_blur: (function (param) {
                                
                              }),
                            prediction_array: autoComletePlaceList,
                            set_prediction_array: (function (val) {
                                Curry._1(dispatch, {
                                      TAG: /* SetAutoComletePlaceList */0,
                                      _0: val
                                    });
                              })
                          }),
                      error: undefined,
                      input_image: waypoint ? SpotEstimateVmV1$PorterinFeature.input_to_icon : SpotEstimateVmV1$PorterinFeature.input_from_iconV1,
                      clear_input: (function ($$event) {
                          Curry._1(dispatch, {
                                TAG: /* SetLandmark */1,
                                _0: ""
                              });
                          onSearchForLocation(undefined);
                        })
                    })), React.createElement(ButtonIconCmp$PorterinFeature.make, {
                  on_click: (function (param) {
                      FareEstimateAnalyticsHelper$PorterinFeature.publishLocationAccuracyEvent(FareEstimateStoreV1$PorterinFeature.use_current_location_click);
                      navigator.geolocation.getCurrentPosition((function (position) {
                              FareEstimateAnalyticsHelper$PorterinFeature.publishLocationAccuracyEvent(FareEstimateStoreV1$PorterinFeature.allow_current_location_click);
                              var lat = position.coords.latitude;
                              var lng = position.coords.longitude;
                              GeocodingApi$PorterinFeature.getGeocodeFromLatLng({
                                    lat: lat,
                                    lng: lng
                                  }, (function (geocode) {
                                      GoogleReactAutocompleteHelper$PorterinFeature.setGeocodingAddress(geocode, on_location_select);
                                    }), (function (param) {
                                      Curry._1(Lib$PorterinFusionkitSentry.React.captureMessage, GoogleStore$PorterinFeature.on_fetch_from_geocode_error);
                                    }));
                            }), (function (error) {
                              FareEstimateAnalyticsHelper$PorterinFeature.publishLocationAccuracyEvent(FareEstimateStoreV1$PorterinFeature.dont_allow_current_location_click);
                              Curry._1(dispatch, {
                                    TAG: /* SetIsPermissionDenied */2,
                                    _0: true
                                  });
                              var error_msg = error.message;
                              switch (error_msg) {
                                case "PERMISSION_DENIED" :
                                    Curry._1(Lib$PorterinFusionkitSentry.React.captureMessage, GoogleStore$PorterinFeature.perminssion_denied);
                                    return ;
                                case "POSITION_UNAVAILABLE" :
                                    Curry._1(Lib$PorterinFusionkitSentry.React.captureMessage, GoogleStore$PorterinFeature.position_unavailable);
                                    return ;
                                case "TIMEOUT" :
                                    Curry._1(Lib$PorterinFusionkitSentry.React.captureMessage, GoogleStore$PorterinFeature.timeout);
                                    return ;
                                default:
                                  Curry._1(Lib$PorterinFusionkitSentry.React.captureMessage, GoogleStore$PorterinFeature.unknown_error);
                                  return ;
                              }
                            }));
                    }),
                  label: waypoint ? SpotEstimateStore$PorterinFeature.locate_on_map_label : SpotEstimateStore$PorterinFeature.current_location_label
                }), state.isPermissionDenied ? React.createElement(PermissionDeniedCmp$PorterinFeature.make, {
                    on_click: (function (param) {
                        onSearchForLocation(undefined);
                      })
                  }) : React.createElement(AutoCompleteSuggestionsCmp$PorterinFeature.make, {
                    places_list: autoComletePlaceList,
                    on_address_select: (function (place) {
                        GoogleReactAutocompleteHelper$PorterinFeature.getAddressDetailsGeocode(place.place_id, Curry.__2(on_location_select));
                        Curry._1(dispatch, {
                              TAG: /* SetAutoComletePlaceList */0,
                              _0: []
                            });
                      })
                  }));
}

var make = SelectLocationCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
